export default {
	terminology: {
		editAction: "Edit terminology",
		searchFields: "Search terminology fields…",
		term: "Term",
		synonyms: "Synonyms",
		translationMissing: "Translation missing",
		autosave: {
			saving: "Saving…",
			saved: "All changes saved",
			error: "Couldn't save — check your connection",
		},
		generate: {
			field: "Generate",
			regenerateField: "Regenerate",
			missing: "Generate missing",
			inProgress: "Generating terminology…",
			cancelling: "Cancelling…",
			done: "Terminology generated for {count} languages",
			unavailable: "AI generation is not configured on this server.",
			empty: "The AI didn't return a usable result — try again.",
			noChange: "Nothing better came to mind — kept the current version.",
		},
		translateLanguage: "Translate this language",
		regenerateLanguage: "Regenerate this language",
		verifyDescriptionFirst: "Verify a description first",
		reviewSuggestionsFirst: "Accept or discard the suggestions first",
		descriptionGateHint:
			"Generate and verify a description to unlock terms, synonyms, and translations.",
		markVerified: "Mark verified",
		verifiedBy: "Verified by {name} on {date}",
		acceptSuggestion: "Accept",
		discardSuggestion: "Discard",
		aiUnverified: "AI · unverified",
		aiProvenance: "From the AI, not verified",
		suggestedReplacement: "Suggested replacement",
		addSynonym: "Add “{term}”",
		noSynonymOptions: "Type a synonym and add it",
		protectedSpanHint:
			"Wrap text in [[double brackets]] to keep it from being translated — the whole field or just part of it.",
		dependencyLabel:
			"This label comes from “{alias}”. Editing it saves your own wording in this project only — “{alias}” is not changed.",
		overrideLabel: "You have your own wording for this term from “{alias}”.",
		resetToDependency: "Reset to “{alias}” label",
		verifyDependency:
			"This label comes from “{alias}” and is verified there. Edit it first to verify your own wording.",
		dependencyNoLabel:
			"This has no label in “{alias}” to relabel here, and it cannot be given one from this project.",
		panelTitle: "Terminology:",
	},
};
